import type { ButtonHTMLAttributes } from 'react'

import { cn } from '@/lib/cn'

export interface SwitchProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'onChange' | 'role'
> {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}

export function Switch({
  checked,
  className,
  disabled,
  onCheckedChange,
  type = 'button',
  ...props
}: SwitchProps) {
  return (
    <button
      aria-checked={checked}
      className={cn(
        'inline-flex h-5 w-9 cursor-pointer items-center rounded-full p-0.5 transition-colors',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-focus)]',
        checked ? 'bg-[var(--color-primary)]' : 'bg-[rgba(26,28,25,0.18)]',
        disabled ? 'cursor-not-allowed opacity-60' : null,
        className,
      )}
      disabled={disabled}
      onClick={() => {
        onCheckedChange(!checked)
      }}
      role="switch"
      type={type}
      {...props}
    >
      <span
        aria-hidden
        className={cn(
          'size-4 rounded-full bg-white shadow-sm transition-transform',
          checked ? 'translate-x-4' : 'translate-x-0',
        )}
      />
    </button>
  )
}
